import React, { useEffect, useRef, useState } from "react"
import "./footer.scss"
import { Form, FloatingLabel, FormGroup } from "react-bootstrap"
import axios from "../../http/axios"
import { useForm } from "react-hook-form"
import ReCAPTCHA from "react-google-recaptcha"
import { SOCIAL_LINKS } from "../../constants/social-links"

const Footer = ({ staticContactsForm, staticContactsPage, recaptchaSettings }) => {
  const reRef = useRef()
  const [errorName, setErrorName] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const [errorPhone, setErrorPhone] = useState(false)
  const { register, handleSubmit, reset, formState } = useForm()

  useEffect(() => {
    const handleTextareaInput = event => {
      if (event.target.tagName.toLowerCase() !== "textarea") return
      const field = event.target
      field.style.height = "inherit"
      const computed = window.getComputedStyle(field)
      const height =
        parseInt(computed.getPropertyValue("border-top-width"), 10) +
        parseInt(computed.getPropertyValue("padding-top"), 10) +
        field.scrollHeight +
        parseInt(computed.getPropertyValue("padding-bottom"), 10) +
        parseInt(computed.getPropertyValue("border-bottom-width"), 10)
      field.style.height = height + "px"
    }

    document.addEventListener("input", handleTextareaInput)
    return () => document.removeEventListener("input", handleTextareaInput)
  }, [])

  const validateField = (event, fieldName) => {
    const value = event.target.value

    if (fieldName === "name") {
      const hasUrl = value.includes("http://") || value.includes("https://") || value.includes(".")
      setErrorName(hasUrl)
    }

    if (fieldName === "message") {
      const hasUrl = value.includes("http://") || value.includes("https://")
      setErrorMessage(hasUrl)
    }

    if (fieldName === "phone") {
      const isValidPhone = /^[ \-+0-9()]+$/.test(value)
      setErrorPhone(!isValidPhone)
    }
  }

  const onSubmit = data => {
    if (data.name && data.phone && data.message && !errorName && !errorMessage && !errorPhone) {
      reRef.current.executeAsync().then(token => {
        const body = { ...data, recaptchaToken: token }
        axios
          .post("/contact-us", body)
          .then(res => {
            if (res.status === 200) {
              reset()
              alert(staticContactsForm["Success"])
            }
            reRef.current.reset()
          })
          .catch(error => {
            alert(error.response.data.message)
          })
      })
    } else {
      alert(staticContactsForm["Fill all fields error"])
    }
  }

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div id="contact-form" className="form-wrapper row pt-5">
            <Form onSubmit={handleSubmit(onSubmit)} className="col-lg-7 mb-4">
              <h1>{staticContactsForm["Header"]}</h1>
              <div className="footer-text-block">{staticContactsForm["Description"]}</div>
              <FormGroup controlId="name">
                <FloatingLabel
                  controlId="name"
                  label={staticContactsForm["Field: Name"]}
                  className="footer-text-block mb-3 mt-5"
                >
                  <Form.Control
                    type="text"
                    placeholder="Name"
                    onInput={e => validateField(e, "name")}
                    {...register("name")}
                    className="curs-P"
                  />
                  {errorName && <span className="field-error">Некоректний формат імені</span>}
                </FloatingLabel>
              </FormGroup>
              <FloatingLabel
                controlId="phone"
                label={staticContactsForm["Field: Phone"]}
                className="footer-text-block mb-3"
              >
                <Form.Control
                  type="text"
                  {...register("phone")}
                  onInput={e => validateField(e, "phone")}
                  placeholder="Phone"
                  className="curs-P"
                />
                {errorPhone && <span className="field-error">Некоректний формат номеру телефону</span>}
              </FloatingLabel>
              <FloatingLabel
                controlId="message"
                label={staticContactsForm["Field: Message"]}
                className="footer-text-block mb-4"
              >
                <Form.Control
                  as="textarea"
                  {...register("message")}
                  onInput={e => validateField(e, "message")}
                  placeholder="Message"
                  className="curs-P"
                />
                {errorMessage && <span className="field-error">Некоректний формат повідомлення</span>}
              </FloatingLabel>
              <button
                type="submit"
                className="btn btn-primary btn-lg col-lg-5 mb-4"
              >
                {staticContactsForm["Submit Button Text"]}
              </button>
              <div
                dangerouslySetInnerHTML={{ __html: staticContactsForm["Submit Privacy HTML"] }}
                className="footer-text-block privacy-text-block"
              />
            </Form>
            <div className="col" />
          </div>
          <div className="navigation__left d-flex justify-content-around mb-4">
            {SOCIAL_LINKS.map(link => (
              <div
                key={link.name}
                className={`navigation__item ${link.name.toLowerCase()}-link`}
              >
                <a href={link.href} target="_blank" rel="noopener noreferrer">
                  {link.name}
                </a>
              </div>
            ))}
          </div>
          <div className="row bottom-part d-flex align-items-center">
            <div className="right-reserved d-flex col-12 col-sm-3 col-md-3 col-lg-6">
              <div>
                © 2022 BigMedia. <br /> All Rights Reserved
              </div>
            </div>
            <div className="address-n-feedback d-flex gap-7 col-12 col-sm-9 col-md-9 col-lg-6">
              <div className="row w-100">
                <div
                  className="col-6"
                  dangerouslySetInnerHTML={{ __html: staticContactsPage["Address Text"] }}
                />
                <div className="col-6">
                  <div dangerouslySetInnerHTML={{ __html: staticContactsPage["Phone HTML"] }} />
                  <span dangerouslySetInnerHTML={{ __html: staticContactsPage["Email HTML"] }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {recaptchaSettings?.enabled && (
        <ReCAPTCHA
          sitekey={recaptchaSettings.publicKey}
          size="invisible"
          ref={reRef}
          onExpired={() => reRef.current.reset()}
        />
      )}
    </>
  )
}

export default Footer
